import { render, staticRenderFns } from "./MetricsAdditionalContract.vue?vue&type=template&id=12865e0d&scoped=true&"
import script from "./MetricsAdditionalContract.vue?vue&type=script&lang=js&"
export * from "./MetricsAdditionalContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12865e0d",
  null
  
)

export default component.exports